export const categories: { slug: string; name: string; icon: string; description: string }[] = [
  { slug: 'dianying', name: '电影', icon: 'ri-movie-2-line', description: '最新大片、经典老片，应有尽有' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-line', description: '热门剧集，追剧不停' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-emotion-laugh-line', description: '热门综艺，欢笑不断' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-camera-lens-line', description: '探索世界，发现真相' },
  { slug: 'dongman', name: '动漫', icon: 'ri-rocket-line', description: '热血动漫，青春回忆' },
];

export const videos: {
  id: string;
  title: string;
  category: string;
  image: string;
  description: string;
  duration: string;
  year: string;
  rating: string;
  tags: string[];
  updateTime: string;
  featured?: boolean;
}[] = [
  {
    id: 'v1',
    title: '流浪地球3',
    category: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20futuristic%20space%20station%20and%20Earth%20in%20background%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20warm%20orange%20and%20gold%20tones%2C%20epic%20blockbuster%20style%2C%20dark%20space%20background%20with%20stars&width=800&height=450&seq=dianying-01&orientation=landscape',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的旅程，年轻一代挺身而出，展开争分夺秒的生死之战。',
    duration: '128分钟',
    year: '2026',
    rating: '9.2',
    tags: ['科幻', '冒险', '国产'],
    updateTime: '2026-08-07',
    featured: true,
  },
  {
    id: 'v2',
    title: '长津湖之水门桥',
    category: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20war%20movie%20poster%20with%20soldiers%20in%20snowy%20mountain%20battlefield%2C%20dramatic%20winter%20scene%2C%20heroic%20composition%2C%20warm%20emotional%20tones%2C%20epic%20cinematic%20style%2C%20dark%20atmospheric%20background&width=800&height=450&seq=dianying-02&orientation=landscape',
    description: '以抗美援朝战争第二次战役中的长津湖战役为背景，中国人民志愿军第九兵团在极寒严酷环境下展开的历史性战役。',
    duration: '149分钟',
    year: '2025',
    rating: '8.9',
    tags: ['战争', '历史', '动作'],
    updateTime: '2026-08-06',
  },
  {
    id: 'v3',
    title: '哪吒之魔童闹海',
    category: 'dongman',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20poster%20with%20mythological%20boy%20character%20with%20fire%20powers%2C%20colorful%20magical%20effects%2C%20traditional%20Chinese%20art%20style%2C%20vibrant%20red%20and%20gold%20colors%2C%20fantasy%20background%20with%20clouds&width=800&height=450&seq=dongman-01&orientation=landscape',
    description: '天劫之后，哪吒和敖丙的灵魂虽然保住了，但肉身即将魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身，但过程中却遭遇重重困难。',
    duration: '110分钟',
    year: '2026',
    rating: '9.5',
    tags: ['动画', '神话', '冒险'],
    updateTime: '2026-08-07',
    featured: true,
  },
  {
    id: 'v4',
    title: '狂飙',
    category: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20TV%20series%20poster%20with%20police%20officer%20and%20suspicious%20atmosphere%2C%20noir%20style%2C%20dark%20urban%20background%2C%20tense%20mood%2C%20warm%20golden%20and%20dark%20tones%2C%20professional%20photography&width=800&height=450&seq=dianshiju-01&orientation=landscape',
    description: '以一线刑警安欣为代表的正义力量，与黑恶势力展开的长达二十年的生死搏斗，通过群像叙事展现扫黑除恶中的黑白较量与复杂人性。',
    duration: '45分钟/集',
    year: '2025',
    rating: '9.1',
    tags: ['刑侦', '悬疑', '剧情'],
    updateTime: '2026-08-05',
    featured: true,
  },
  {
    id: 'v5',
    title: '奔跑吧·黄河篇',
    category: 'zongyi',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20celebrities%20running%20and%20laughing%20outdoors%2C%20bright%20sunny%20day%2C%20colorful%20casual%20clothing%2C%20energetic%20vibe%2C%20warm%20sunlight%2C%20cheerful%20atmosphere%2C%20entertainment%20style&width=800&height=450&seq=zongyi-01&orientation=landscape',
    description: '跑男团成员们沿着黄河流域展开精彩冒险，深入探索黄河文化，体验各地风土人情，为观众带来欢笑与感动。',
    duration: '90分钟/期',
    year: '2026',
    rating: '8.3',
    tags: ['户外', '竞技', '搞笑'],
    updateTime: '2026-08-07',
  },
  {
    id: 'v6',
    title: '蓝色星球III',
    category: 'jilupian',
    image: 'https://readdy.ai/api/search-image?query=BBC%20style%20nature%20documentary%20poster%20with%20deep%20ocean%20scene%2C%20colorful%20coral%20reef%20and%20marine%20life%2C%20crystal%20clear%20water%2C%20sunlight%20rays%20penetrating%20water%20surface%2C%20stunning%20underwater%20photography%2C%20vibrant%20colors&width=800&height=450&seq=jilupian-01&orientation=landscape',
    description: '深入探索海洋世界的奥秘，从浅海到深海，揭示前所未见的海洋生物和生态系统，用最先进的拍摄技术呈现震撼的海洋奇观。',
    duration: '60分钟/集',
    year: '2026',
    rating: '9.7',
    tags: ['自然', '海洋', 'BBC'],
    updateTime: '2026-08-06',
  },
  {
    id: 'v7',
    title: '封神第二部',
    category: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20film%20poster%20with%20ancient%20warriors%20and%20magical%20creatures%2C%20epic%20battle%20scene%2C%20traditional%20Chinese%20elements%2C%20dramatic%20lighting%2C%20gold%20and%20crimson%20tones%2C%20grand%20cinematic%20style&width=800&height=450&seq=dianying-03&orientation=landscape',
    description: '殷寿暴虐无道，引发天谴。昆仑仙人姜子牙携封神榜下山，寻找天下共主以救苍生。一场人、仙、妖之间的旷世之战即将展开。',
    duration: '135分钟',
    year: '2026',
    rating: '8.7',
    tags: ['神话', '奇幻', '动作'],
    updateTime: '2026-08-04',
  },
  {
    id: 'v8',
    title: '庆余年2',
    category: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20ancient%20Chinese%20costume%20characters%2C%20palace%20setting%2C%20elegant%20traditional%20aesthetics%2C%20warm%20golden%20lighting%2C%20mysterious%20atmosphere%2C%20film%20quality%20cinematography&width=800&height=450&seq=dianshiju-02&orientation=landscape',
    description: '范闲身世之谜逐渐揭开，各方势力暗流涌动。在这盘大棋中，范闲将如何运筹帷幄，守护自己珍视的一切？',
    duration: '45分钟/集',
    year: '2026',
    rating: '9.0',
    tags: ['古装', '权谋', '剧情'],
    updateTime: '2026-08-07',
  },
  {
    id: 'v9',
    title: '斗破苍穹·年番',
    category: 'dongman',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20style%20poster%20with%20young%20warrior%20holding%20flaming%20sword%2C%20fantasy%20mountain%20landscape%2C%20dynamic%20action%20pose%2C%20magical%20fire%20effects%2C%20vibrant%20colors%2C%20epic%20adventure%20theme%2C%20anime%20art%20style&width=800&height=450&seq=dongman-02&orientation=landscape',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后，突然成了废人，种种打击接踵而至。在他即将绝望时，一缕幽魂从他手上的戒指里浮现。',
    duration: '20分钟/集',
    year: '2026',
    rating: '8.5',
    tags: ['玄幻', '热血', '3D'],
    updateTime: '2026-08-07',
  },
  {
    id: 'v10',
    title: '地球脉动IV',
    category: 'jilupian',
    image: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20majestic%20mountain%20range%20and%20wildlife%2C%20eagle%20flying%20over%20peaks%2C%20golden%20sunset%20light%2C%20stunning%20landscape%20photography%2C%20warm%20earthy%20tones%2C%20breathtaking%20vista&width=800&height=450&seq=jilupian-02&orientation=landscape',
    description: '从最高的山峰到最深的海洋，从最炎热的沙漠到最寒冷的冰原，展现地球上最壮丽的自然景观和野生动物的生存奇迹。',
    duration: '60分钟/集',
    year: '2026',
    rating: '9.8',
    tags: ['自然', '地理', 'BBC'],
    updateTime: '2026-08-03',
  },
  {
    id: 'v11',
    title: '王牌对王牌·第九季',
    category: 'zongyi',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20stage%20poster%20with%20celebrities%20playing%20games%20on%20colorful%20studio%20set%2C%20bright%20stage%20lighting%2C%20fun%20atmosphere%2C%20game%20show%20style%2C%20warm%20and%20vibrant%20colors%2C%20entertainment%20photography&width=800&height=450&seq=zongyi-02&orientation=landscape',
    description: '王牌家族再度集结，经典IP对决继续上演。每期邀请重磅嘉宾，爆笑游戏不断，精彩才艺轮番登场。',
    duration: '100分钟/期',
    year: '2026',
    rating: '8.1',
    tags: ['棚内', '游戏', '搞笑'],
    updateTime: '2026-08-06',
  },
  {
    id: 'v12',
    title: '满江红2',
    category: 'dianying',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20film%20poster%20set%20in%20ancient%20China%2C%20courtyard%20scene%20with%20soldiers%2C%20dark%20moody%20lighting%2C%20mysterious%20atmosphere%2C%20red%20lanterns%2C%20traditional%20architecture%2C%20cinematic%20photography&width=800&height=450&seq=dianying-04&orientation=landscape',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一桩谜案牵动朝野，一个小兵与亲兵营副统领被迫卷入了一场更大的阴谋之中。',
    duration: '142分钟',
    year: '2026',
    rating: '8.6',
    tags: ['悬疑', '历史', '喜剧'],
    updateTime: '2026-08-05',
  },
  {
    id: 'v13',
    title: '三体·黑暗森林',
    category: 'dianshiju',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20with%20cosmic%20theme%2C%20dark%20space%20and%20galaxies%2C%20mysterious%20alien%20civilization%20concept%2C%20futuristic%20technology%2C%20deep%20space%20colors%2C%20philosophical%20mood%2C%20high%20concept%20design&width=800&height=450&seq=dianshiju-03&orientation=landscape',
    description: '三体文明锁定地球后，人类面临前所未有的生存危机。面壁计划启动，四位面壁者开始与三体世界展开了一场跨越光年的智慧较量。',
    duration: '50分钟/集',
    year: '2026',
    rating: '9.3',
    tags: ['科幻', '悬疑', '改编'],
    updateTime: '2026-08-07',
  },
  {
    id: 'v14',
    title: '仙逆',
    category: 'dongman',
    image: 'https://readdy.ai/api/search-image?query=Chinese%203D%20animation%20cultivation%20fantasy%20poster%20with%20immortal%20cultivator%20flying%20on%20sword%2C%20mountain%20peaks%20in%20clouds%2C%20magical%20glowing%20effects%2C%20mystical%20atmosphere%2C%20ancient%20Chinese%20fantasy%20style%2C%20epic%20landscape&width=800&height=450&seq=dongman-03&orientation=landscape',
    description: '平庸少年王林凭借一颗天逆珠，逆天改命，踏上修仙之路。从凡人到仙帝，历经万劫，终成大道。',
    duration: '22分钟/集',
    year: '2026',
    rating: '8.8',
    tags: ['修仙', '热血', '3D'],
    updateTime: '2026-08-06',
  },
  {
    id: 'v15',
    title: '舌尖上的中国V',
    category: 'jilupian',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20delicious%20traditional%20Chinese%20dishes%20on%20wooden%20table%2C%20steaming%20hot%20food%2C%20warm%20kitchen%20atmosphere%2C%20rich%20colors%20of%20ingredients%2C%20appetizing%20food%20photography%2C%20cultural%20cooking%20scene&width=800&height=450&seq=jilupian-03&orientation=landscape',
    description: '穿越中国广袤的土地，探寻最地道的美食文化。从街头小吃到宴席大菜，每道美食背后都有动人的故事。',
    duration: '50分钟/集',
    year: '2026',
    rating: '9.4',
    tags: ['美食', '文化', '国产'],
    updateTime: '2026-08-04',
  },
  {
    id: 'v16',
    title: '向往的生活·第十季',
    category: 'zongyi',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20slow%20life%20variety%20show%20poster%20with%20countryside%20house%20and%20garden%2C%20celebrities%20cooking%20and%20farming%2C%20peaceful%20rural%20scene%2C%20warm%20sunset%20lighting%2C%20cozy%20atmosphere%2C%20natural%20lifestyle%20theme&width=800&height=450&seq=zongyi-03&orientation=landscape',
    description: '在远离城市喧嚣的田园小屋中，主人们自给自足，招待远道而来的朋友，享受简单而美好的生活。',
    duration: '100分钟/期',
    year: '2026',
    rating: '8.7',
    tags: ['生活', '慢综艺', '美食'],
    updateTime: '2026-08-07',
  },
];